import { Cell, Grid } from 'bold-ui'
import {
  RacionalidadeEmSaudeSelectField,
  RacionalidadeEmSaudeSelectModel,
} from 'components/form/field/select/RacionalidadeEmSaudeSelectField'
import { resolveValue } from 'components/form/final-form/useField'
import {
  CondutaEnum,
  CondutaOdontoEnum,
  FornecimentoOdontoEnum,
  TipoAtendimentoEnum,
  TipoAtendimentoProfissional,
  TipoConsultaOdontoEnum,
} from 'graphql/types.generated'
import React from 'react'
import { useFormState } from 'react-final-form'
import { MetaPath } from 'util/metaPath'
import { isEmpty } from 'util/validation/Util'
import { AgendamentoDia } from 'view/atendimentos/types/AgendamentoDia'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { LotacaoSelectField, LotacaoSelectFieldModel } from '../../../../profissional/lotacao/LotacaoSelectField'
import { CondutaOdontoPanel } from './components/CondutaOdontoPanel'
import { CondutaPanel } from './components/CondutaPanel'
import { DesfechoAtendimentoFormModel, DesfechoAtendimentoPanel } from './components/DesfechoAtendimentoPanel'
import { FornecimentoPanel } from './components/FornecimentoPanel'
import {
  NotificacaoCasoSuspeitoField,
  NotificacaoCasoSuspeitoFieldModel,
} from './components/NotificacaoCasoSuspeitoField'
import { ProcedimentoSigtapField, ProcedimentoSigtapFieldModel } from './components/ProcedimentoSigtapField'
import { TipoAtendimentoPanel } from './components/TipoAtendimentoPanel'
import { TipoConsultaPanel } from './components/TipoConsultaPanel'

export interface DesfechoFormModel {
  tipoAtendimento?: TipoAtendimentoEnum
  tipoConsulta?: TipoConsultaOdontoEnum
  atendimentoCompartilhado?: LotacaoSelectFieldModel
  fornecimento?: FornecimentoOdontoEnum[]
  procedimentosAdministrativos?: Array<ProcedimentoSigtapFieldModel>
  fichasNotifiacaoCasoSuspeito?: Array<NotificacaoCasoSuspeitoFieldModel>
  racionalidadeEmSaude?: RacionalidadeEmSaudeSelectModel
  conduta?: CondutaEnum[]
  condutasOdonto?: CondutaOdontoEnum[]
  desfechoAtendimento?: DesfechoAtendimentoFormModel
}

export interface DesfechoFormProps {
  name: MetaPath<DesfechoFormModel>
  profissionalId?: ID
  dataAtendimento: Instant
  isDemandaEspontanea?: boolean
  cidadao: CidadaoAtendimento
  agendamentosDia?: AgendamentoDia[]
  tipoAtendProf: TipoAtendimentoProfissional
}

export function DesfechoForm(props: DesfechoFormProps) {
  const { cidadao, isDemandaEspontanea, profissionalId, name, dataAtendimento, agendamentosDia, tipoAtendProf } = props

  const { values: formValues } = useFormState({ subscription: { values: true } })
  const isAtendimentoOdonto = tipoAtendProf === TipoAtendimentoProfissional.ATENDIMENTO_ODONTOLOGICO
  const showTipoAtendimentoPanel = !isAtendimentoOdonto || (isAtendimentoOdonto && isDemandaEspontanea)

  const values = resolveValue(formValues, name)
  return (
    <>
      <Grid gapVertical={1}>
        {showTipoAtendimentoPanel && (
          <Cell size={12}>
            <TipoAtendimentoPanel name={name.tipoAtendimento} isDemandaEspontanea={isDemandaEspontanea} />
          </Cell>
        )}
        {isAtendimentoOdonto && (
          <Cell size={12}>
            <TipoConsultaPanel
              name={name.tipoConsulta}
              isDemandaEspontanea={isDemandaEspontanea}
              isUrgencia={values.tipoAtendimento === TipoAtendimentoEnum.URGENCIA}
            />
          </Cell>
        )}
        <Cell size={8}>
          <LotacaoSelectField
            excludeProfissional={profissionalId}
            name={name.atendimentoCompartilhado}
            label='Atendimento compartilhado'
          />
        </Cell>
        {isAtendimentoOdonto && (
          <Cell size={8}>
            <FornecimentoPanel name={name.fornecimento} />
          </Cell>
        )}
        <Cell size={12}>
          <ProcedimentoSigtapField name={name.procedimentosAdministrativos} cidadao={cidadao} />
        </Cell>
        <Cell size={12}>
          <NotificacaoCasoSuspeitoField
            name={name.fichasNotifiacaoCasoSuspeito}
            cidadaoId={cidadao?.id}
            dataAtendimento={dataAtendimento}
          />
        </Cell>
        <Cell size={8}>
          <RacionalidadeEmSaudeSelectField
            name={name.racionalidadeEmSaude}
            label='Racionalidade em saúde (Exceto alopatia/convencional)'
          />
        </Cell>
        <Cell size={12}>
          {isAtendimentoOdonto ? (
            <CondutaOdontoPanel name={name.condutasOdonto} tipoConsulta={values.tipoConsulta} />
          ) : (
            <CondutaPanel
              name={name.conduta}
              hasNotificacaoCasoSuspeito={!isEmpty(values?.fichasNotifiacaoCasoSuspeito)}
            />
          )}
        </Cell>
        <Cell size={12}>
          <DesfechoAtendimentoPanel name={name.desfechoAtendimento} agendamentosDia={agendamentosDia} />
        </Cell>
      </Grid>
    </>
  )
}
